<template>
  <v-dialog v-model="show" width="550" class="rounded-lg" persistent scrollable>
    <v-card class="base rounded-lg" tile>
      <v-toolbar flat dark color="base">
        <v-toolbar-title>
          Conectar com o
          <strong
            ><u>
              {{ integration.title }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ml-1">
                    <InfoIcon size="small" />
                  </span>
                </template>
                <span>{{ integration.info }}</span>
              </v-tooltip>
            </u></strong
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mt-0 mr-0" dark icon @click="$emit('close')">
          <CloseIcon />
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader class="rounded-lg" v-if="isFacebookPixel">
          <v-list-item>
            <v-list-item-content class="pt-6">
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.facebookPixelID"
                    label="Pixel ID"
                    placeholder="Número de identificação do pixel"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.facebookPixelTestID"
                    label="Test ID"
                    placeholder="Número de identificação do pixel de teste"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.facebookPixelToken"
                    label="Token API"
                    :noMaxLength="true"
                    placeholder="Token de acesso à API do Facebook"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list three-line subheader class="rounded-lg" v-if="isGoogleAds">
          <v-list-item>
            <v-list-item-content class="pt-6">
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.googleAdsID"
                    label="ID de conversão"
                    placeholder="Ex: AW-123456789"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.googleAdsScript"
                    label="Script de conversão"
                    placeholder="Ex: AW-CONVERSION_ID/CONVERSION_LABEL"
                    hide-details
                    :noMaxLength="true"
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list
          three-line
          subheader
          class="rounded-lg"
          v-if="isGoogleAnalytics"
        >
          <v-list-item>
            <v-list-item-content class="pt-6">
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.googleAnalyticsID"
                    label="Código do Google Analytics"
                    placeholder="Ex: G-123456-7"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list
          three-line
          subheader
          class="rounded-lg"
          v-if="isGoogleTagManager"
        >
          <v-list-item>
            <v-list-item-content class="pt-6">
              <v-row>
                <v-col cols="12">
                  <BaseTextField
                    v-model="integration.googleTagManagerID"
                    label="Código do Google Tag Manager"
                    placeholder="Número de indentificação do GTM"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="pr-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          class="order-2 rounded-lg"
          dark
          dense
          :loading="connectLoading"
          @click="$emit('connect', integration)"
          >{{ connect }}</v-btn
        >
        <v-btn class="rounded-lg mr-4 order-1" text @click="$emit('close')">
          {{ cancel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import InfoIcon from "@/components/icons/InfoIcon.vue";
export default {
  name: "IntegrationDialog",
  components: {
    CloseIcon,
    BaseTextField,
    InfoIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    connectLoading: {
      type: Boolean,
      default: false,
      required: true,
    },
    integration: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      connect: "CONECTAR",
      cancel: "CANCELAR",
    };
  },
  computed: {
    isFacebookPixel() {
      const { integration } = this.integration;
      return integration === "facebookPixel";
    },
    isGoogleAds() {
      const { integration } = this.integration;
      return integration === "googleAds";
    },
    isGoogleAnalytics() {
      const { integration } = this.integration;
      return integration === "googleAnalytics";
    },
    isGoogleTagManager() {
      const { integration } = this.integration;
      return integration === "googleTagManager";
    },
  },
};
</script>

<style scoped>
.text-subtitle-1 {
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
}
.modal-container {
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}

.select-product-modal {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20%;
  display: flex;
  justify-content: flex-end;
}
</style>
